import z from 'zod';

export const Step1Schema = z.object({
    page: z.string({ message: 'آیدی پیج الزامی است' }).min(1, 'حداقل 1 کاراکتر').max(50, 'حداکثر 50 کاراکتر')
});

export const Step2Schema = z
    .object({
        field_id: z
            .any()
            .refine((val) => val !== '' && val !== null && val !== undefined, {
                message: 'انتخاب حوزه کاری الزامی است'
            })
            .transform((val) => (typeof val === 'string' ? Number(val) : val)),
        category_id: z
            .union([z.number(), z.string()])
            .refine((val) => val !== '' && val !== null && val !== undefined, {
                message: 'انتخاب دسته‌بندی الزامی است'
            })
            .transform((val) => (typeof val === 'string' ? Number(val) : val)),
        is_store: z.boolean().default(false),
        store_type: z.string().default('')
    })
    .superRefine((data, ctx) => {
        // اگر فروشگاهی است، store_type الزامی است
        if (data.is_store === true) {
            if (!data.store_type || data.store_type.trim().length === 0) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    path: ['store_type'],
                    message: 'انتخاب تعداد تنوع محصولات الزامی است'
                });
            } else {
                console.log('✅ store_type is valid:', data.store_type);
            }
        } else {
            console.log('ℹ️ Not a store, skipping store_type validation');
        }
    });

export const Step3Schema = z.object({
    page_category: z
        .string({ message: 'توضیحات پیج الزامی میباشد' })
        .min(10, 'حداقل ۱۰ کاراکتر')
        .max(200, 'حداکثر ۲۰۰ کاراکتر')
});

export const Step4Schema = z.object({
    start_after_days: z.number({ message: 'انتخاب تاریخ شروع الزامی است' }).min(1, 'لطفاً تاریخ شروع را انتخاب کنید'),
    best_post_time: z.string({ message: 'انتخاب بازه زمانی الزامی است' }).min(1, 'لطفاً بازه زمانی را انتخاب کنید')
});

export const Step5Schema = z.object({
    video_style_id: z.string({ message: 'انتخاب سبک ویدیویی الزامی است' }).min(1, 'لطفاً سبک ویدیویی را انتخاب کنید')
});

export const AddPageFullFormSchema = Step1Schema.merge(Step2Schema)
    .merge(Step3Schema)
    .merge(Step4Schema)
    .merge(Step5Schema);

export type AddPageFullFormValues = z.infer<typeof AddPageFullFormSchema>;

